import React from 'react'
import {Button, Modal, ModalBody, ModalHeader, UncontrolledTooltip} from "reactstrap";
import {CustomHeader, FleetButton} from "@pages/new-design-components/custom-components";
import {parseToWord} from "@constants/index";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";


export default function CreateTemplateModal({isOpen, localData = null,  closeModal, selectReminder}) {


    return (
        <Modal
            isOpen={isOpen}
            toggle={closeModal}
            modalClassName={'slide-in-from-right'}
            backdrop={false}
            className={'modal-dialog-right modal-responsible'}
        >

            <ModalHeader toggle={closeModal} className={'bg-white centered-title'}>
                <CustomHeader weight={'600'} fontSize={'14px'} color={'#74787E'}>
                    Choose template
                </CustomHeader>
            </ModalHeader>
            <ModalBody>

                {
                        localData.map((reminder,index) => {
                            return <div>
                                <div className={'d-flex justify-content-between'}>
                                    <CustomHeader marginBottom={'6px'} fontSize={'14px'} weight={'400'} color={'#000'}>
                                        {reminder?.subject ? parseToWord(reminder?.subject) : '-'}
                                    </CustomHeader>

                                    <div className={'cursor-pointer d-flex g-10 justify-content-center align-items-center'}>
                                        {reminder?.disabled && <>
                                            <IcoMoon
                                                className={'cursor-pointer'}
                                                iconSet={IconSet}
                                                id={`uncontrolledTooltipExample_${index}`}
                                                icon={'ic_info'}
                                                size={16}
                                            />
                                                <UncontrolledTooltip
                                                    placement="auto"
                                                    target={`uncontrolledTooltipExample_${index}`}
                                                >
                                                    Disabled: No customer deal.
                                                </UncontrolledTooltip>
                                        </>


                                        }
                                        <FleetButton
                                            height={'40px'}
                                            backgroundColor={'#c9c9c978'}
                                            hoverColor={'#c9c9c978'}
                                            color={'#000'}
                                            disabled={reminder?.disabled}
                                            fontSize={'14px'}
                                            radius={'32px'}
                                            onClick={()=>{selectReminder(index)}}
                                        >
                                            Choose
                                        </FleetButton>
                                    </div>
                                </div>
                                <CustomHeader className={'clamp-text'} marginBottom={'6px'} fontSize={'14px'} weight={'400'} color={'#000'}>
                                    {parseToWord(reminder?.message)}
                                </CustomHeader>
                            </div>
                        })
                }

            </ModalBody>

        </Modal>
    )
}